/* import __COLOCATED_TEMPLATE__ from './spaces-header.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();